import styled, { keyframes } from 'styled-components';

const slide = keyframes`
    0% { transform:translateX(-100%); }
    100% { transform:translateX(100%); }
`;

export default styled.div`
    background-color: #eee;
    border-radius: 10px;
    display: ${({ display }) => display || 'block'}
    flex: ${({ flex }) => flex};
    float: ${({ float }) => float};
    height: ${({ height }) => height};
    margin: ${({ margin }) => margin};
    width: ${({ width }) => width || '100%'};
    ${({ animated }) => {
        if (animated) {
            return `&::after {
                content:'';
                transform: translateX(100%);
                width: ${({ width }) => width};
                height: ${({ height }) => height};
                position: absolute;
                z-index:1;
                animation: ${slide} 1s infinite;
                background: linear-gradient(to right, rgba(255,255,255,0) 0%,rgba(255,255,255,0.8) 50%,rgba(128,186,232,0) 99%,rgba(125,185,232,0) 100%);
            }`;
        }

        return null;
    }}
`;
